<slick-dialog #dialogRef header="Edit Account Types" width="600" top="140">

	<table class="js-table">
		<colgroup>
			<col />
			<col style="width: 60px" />
		</colgroup>
		<thead>
			<tr>
				<th>Account Type</th>
				<th>Active</th>
			</tr>
		</thead>

		<tbody>
			<tr *ngFor="let accountType of accountTypes">
				<td>
					<input type="text" class="form-control" style="height: 28px;" [(ngModel)]="accountType.description" />
					<form-error *ngIf="isSubmitted && accountType.businessDevelopmentAccountTypeId > 0 && !accountType.description">Account Type is required</form-error>
				</td>
				<td style="text-align: center">
					<input type="checkbox" [(ngModel)]="accountType.active"  style="margin-top: 6px;" />
				</td>
			</tr>
		</tbody>
	</table>

	<button class="btn btn-link" (click)="addNewAccountType()"><i class="far fa-plus"></i> Add New Account Type</button>
	<slick-dialog-footer>
		<button type="button" [slick-button-spinner]="spinnerStatus" class="btn btn-outline-primary save-button" (click)="onSave()"><i class="far fa-save"></i>&nbsp;Save</button>
		<button type="button" class="btn btn-outline-danger cancel-button" (click)="onCancel()"><i class="far fa-ban"></i>&nbsp;Cancel</button>
	</slick-dialog-footer>
</slick-dialog>